import isObject from '#shared/util/isObject.js';

import defaultGlobal from '#themes/default/default/components/global/global.js';

import cBreadcrumb from '#themes/default/web/components/breadcrumb/breadcrumb.js';
import cError from '#themes/default/web/components/error/error.js';
import cFooter from '#themes/default/web/components/footer/footer.js';
import cModal from '#themes/default/web/components/modal/modal.js';
import cNotificationBar from '#themes/default/web/components/notificationBar/notificationBar.js';
import cPageLayout from '#themes/default/web/layouts/pageLayout/pageLayout.js';
import cPaymentMethods from '#themes/default/web/components/paymentMethods/paymentMethods.js';
import cPaymentSelection from '#themes/default/web/components/paymentSelection/paymentSelection.js';
import cSidebar from '#themes/default/web/components/sidebar/sidebar.js';
import cSvgStorage from '#themes/default/web/components/svgStorage/svgStorage.js';
import cTopHeader from '#themes/default/web/components/topHeader/topHeader.js';

import template from './html/global.html' with { type: 'html' };

export default {
	middleware: defaultGlobal.middleware,
	components: {
		cBreadcrumb,
		cError,
		cFooter,
		cModal,
		cNotificationBar,
		cPageLayout,
		cPaymentMethods,
		cPaymentSelection,
		cSidebar,
		cSvgStorage,
		cTopHeader
	},
	extends: defaultGlobal,
	computed: {
		isInvoicePage() {
			return isObject(this.page) && this.page.number === 5;
		},
		isMobileDevice() {
			// Everything less than 768px is consider to be a phone or a small tablet
			const isSmallDevice = Math.min(window.screen.width, window.screen.height) < 768;
			// Check screen dimensions or userAgent 'Mobi' which indicates that the device is a phone
			return isSmallDevice || navigator.userAgent.indexOf('Mobi') > -1;
		}
	},
	template
};
